import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button, Field, Input } from "@/components/design-system";
import { api, formatApiError } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function ResetPassword() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords don't match."); return; }
    if (!token) { setError("Missing reset token."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setOk(true);
      setTimeout(() => nav("/login", { replace: true }), 1200);
    } catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthLayout eyebrow="Password reset" title="Choose a new password" footer={<Link to="/login" className="text-[#2D7FF9] font-semibold">Back to login</Link>}>
      {ok ? (
        <p className="text-[#0B1F3A]/80">Password updated. Redirecting to login…</p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5">
          <Field label="New password" htmlFor="rp-pw">
            <Input id="rp-pw" data-testid={TID.auth.resetPassword} type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <Field label="Confirm password" htmlFor="rp-pw2">
            <Input id="rp-pw2" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </Field>
          {error && <p className="text-sm font-medium text-red-600">{error}</p>}
          <Button data-testid={TID.auth.resetSubmit} type="submit" variant="primary" className="w-full" disabled={busy}>{busy ? "Updating…" : "Update password"}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
